<template>
  <div v-if="!item.hidden">
    <template v-if="hasNoShowingChild(item.children, item)">
      <router-link :to="resolvePath(hasNoChild.path)">
        <el-menu-item :index="resolvePath(hasNoChild.path)" @click="toLink(item)" :style="isActive">
          <img class="menu-icon" v-if="item.meta && item.meta.icon && !fromSaas" :src="src" alt="">
          <span>{{ hasNoChild.meta && hasNoChild.meta.title || hasNoChild.name || '' }}</span>
        </el-menu-item>
      </router-link>
    </template>

    <el-submenu v-else :index="resolvePath(item.path)" popper-append-to-body :style="isActive">
      <template slot="title">
        <div>
          <img class="menu-icon" v-if="item.meta && item.meta.icon && !fromSaas" :src="src" alt="">
          <span>{{item.meta && item.meta.title || item.name || ''}}</span>
        </div>
      </template>
      <sidebar-item
        v-for="child in item.children"
        :key="child.path"
        :item="child"
        :base-path="resolvePath(child.path)"
        :fromSaas="fromSaas"
        @toLink="item => $emit('toLink', item)">
      </sidebar-item>
    </el-submenu>
  </div>
</template>
<script>
import path from 'path'
import { isExternal } from '@/utils/utils'
import Variables from '@/styles/variables.less'

export default {
  name: 'SidebarItem',
  props: {
    item: {
      type: Object,
      required: true
    },
    basePath: {
      type: String,
      default: ''
    },
    fromSaas: {
      type: Boolean,
      default: false
    }
  },
  data () {
    this.hasNoChild = null
    return {
      src: (this.item.meta && this.item.meta.icon) ? require(`@/assets/menuIcon/${this.item.meta.icon}`) : ''
    }
  },
  computed: {
    isActive () {
      return {
        '--activeBg': this.fromSaas ? Variables.menuActiveBgForSaas : Variables.menuActiveBg,
        '--activeText': this.fromSaas ? Variables.menuActiveTextForSaas : Variables.menuActiveText,
        '--hoverBg': this.fromSaas ? Variables.menuHoverForSaas : Variables.menuHover,
        '--subMenuBg': this.fromSaas ? Variables.subMenuBgForSaas : Variables.subMenuBg
      }
    }
  },
  methods: {
    hasNoShowingChild (children = [], parent) {
      const showingChildren = children.filter(item => {
        if (item.hidden) {
          return false
        } else {
          this.hasNoChild = item
          return true
        }
      })

      // 如果只有一个子菜单，则作为一级路由显示
      if (showingChildren.length === 1) {
        return true
      }

      if (showingChildren.length === 0) {
        this.hasNoChild = { ... parent, path: '' }
        return true
      }
      return false
    },
    resolvePath (routePath) {
      if (isExternal(routePath)) {
        return routePath
      }
      if (isExternal(this.basePath)) {
        return this.basePath
      }
      return path.resolve(this.basePath, routePath)
    },
    toLink (item) {
      let curRoute = item.children ? item.children.find(item => !item.hidden) : item
      this.$emit('toLink', {...curRoute, fullPath: item.redirect || this.basePath})
    }
  }
}
</script>
<style lang="less" scoped>
  .el-menu-item.is-active {
    background-color: var(--activeBg) !important;
    color: var(--activeText) !important;
  }
  /deep/.el-submenu__title:hover, .el-menu-item:hover:not(.is-active) {
    background-color: var(--hoverBg) !important;
  }
  /deep/.el-menu .el-menu-item  {
    background-color: var(--subMenuBg);
  }
</style>
